module.exports = __webpack_public_path__ + "static/media/instagram_us.bcbdef2a.png";